import React from "react";
import "../css/Help.css";

function Help() {
  return (
    <div className="Help-root-container">
      <h4> Help </h4>
    </div>
  );
}

export default Help;
